module.exports = __webpack_public_path__ + "img/icon70.22b7440b.png";